import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";

const TipLoader = React.memo(() => {
  // Shared skeleton props for better consistency and maintenance
  const tipButtonProps = {
    className: "skeleton-placeholder",
    animation: "wave",
    variant: "rounded",
    height: 35,
    width: "24%",
    maxWidth: "25%",
  };

  return (
    <Stack spacing={1}>
      {/* Title skeleton */}
      <Skeleton animation="wave" width="30%" height={20} />

      {/* Tip buttons container */}
      <Box
        sx={{
          width: "100%",
          p: 1,
          justifyContent: "space-between",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
        }}
      >
        {/* Create array of 4 tip button skeletons */}
        {Array(4)
          .fill()
          .map((_, index) => (
            <Skeleton key={`tip-button-${index}`} {...tipButtonProps} />
          ))}
      </Box>

      {/* Message area title */}
      <Skeleton animation="wave" width="40%" height={20} />

      {/* Message text area */}
      <Skeleton
        className="skeleton-placeholder"
        animation="wave"
        variant="rounded"
        width="100%"
        height={125}
      />

      {/* Footer action buttons */}
      <Box
        sx={{
          width: "100%",
          p: 2,
          justifyContent: "flex-end",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
        }}
      >
        <Skeleton
          className="skeleton-placeholder"
          animation="wave"
          variant="rounded"
          width={100}
          height={35}
          sx={{ mr: 1.5 }}
        />
        <Skeleton
          className="skeleton-placeholder"
          animation="wave"
          variant="rounded"
          width={100}
          height={35}
        />
      </Box>
    </Stack>
  );
});

export default TipLoader;
